import Image from "next/image"
import React from "react"
import type { TeamLinkedinNames } from "services/analytics"
import { trackTeamLinkedinClick } from "services/analytics"

import { Box } from "components/shared/box"
import { LinkedIn } from "components/shared/icons/linkedin"
import { GradientBox } from "components/shared/landing/gradient-box"
import { Section } from "components/shared/landing/section"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

const teamMembers: Array<MemberBlockProps> = [
  {
    eventLabel: "simon",
    title: "Simon Shikharev",
    subtitle: "Co-founder",
    avatarPath: "/images/sections/team-section/simon_shikharev.png",
    linkdn: "https://www.linkedin.com/in/simon-shiharev-a7355550/",
  },
  {
    eventLabel: "alex",
    title: "Alex Pavlov",
    subtitle: "Co-founder",
    avatarPath: "/images/sections/team-section/alex_pavlov.png",
    linkdn: "https://www.linkedin.com/in/alekspi/",
  },
  {
    eventLabel: "serg",
    title: "Serg Maslow",
    subtitle: "CEO",
    avatarPath: "/images/sections/team-section/serg_maslow.png",
    linkdn: "https://www.linkedin.com/in/sergey-maslov/",
  },
  {
    eventLabel: "konstantin",
    title: "Konstantin Lomashuk",
    subtitle: "Co-founder",
    avatarPath: "/images/sections/team-section/konstantin_lomashuk.png",
    linkdn: "https://www.linkedin.com/in/lomashuk/",
  },
  {
    eventLabel: "dmitri",
    title: "Dmitri Fil",
    subtitle: "Co-founder",
    avatarPath: "/images/sections/team-section/dmitri_fil.png",
    linkdn: "https://www.linkedin.com/in/dvfilatov1981/",
  },
  // {
  //   eventLabel: "aliaksandr",
  //   title: "Aliaksandr Vasilenka",
  //   subtitle: "Leading game designer",
  //   avatarPath: "/images/sections/team-section/alexandr_vasilenka.png",
  //   linkdn: "https://www.linkedin.com/in/aliaksandr-vasilenka-21788b22/",
  // },
  // {
  //   eventLabel: "daniil",
  //   title: "Daniil Chetverikov",
  //   subtitle: "Lead of Community & SMM",
  //   avatarPath: "/images/sections/team-section/daniil_chetverikov.png",
  //   linkdn: "https://www.linkedin.com/in/daniil-chetverikov-989703158/",
  // },
  {
    eventLabel: "ekaterina",
    title: "Ekaterina Tsaprilova",
    subtitle: "COO",
    avatarPath: "/images/sections/team-section/ekaterina_tsaprilova.png",
    linkdn: "https://www.linkedin.com/in/katya-tsaprilova-8a843b168/",
  },
]

type TeamSectionProps = {
  higherBottomMargin?: boolean
}

export function TeamSection({ higherBottomMargin }: TeamSectionProps) {
  return (
    <Section
      higherBottomMargin={higherBottomMargin}
      className="px-0 md:px-0 lg:px-4"
      header={
        <>
          Core <span className="text-primary">Team</span>
        </>
      }
    >
      <Box row className="w-full overflow-x-auto lg:gap-7 lg:items-center lg:justify-center lg:flex-wrap">
        {teamMembers.map(member => (
          <MemberBlock key={member.title} {...member} />
        ))}
      </Box>
    </Section>
  )
}

type MemberBlockProps = {
  title: string
  subtitle: string
  avatarPath: string
  linkdn: string
  eventLabel: TeamLinkedinNames
}

export function MemberBlock({ title, subtitle, avatarPath, linkdn, eventLabel }: MemberBlockProps) {
  return (
    <GradientBox
      center
      className="shrink-0 w-[220px] mx-2 first:ml-4 last:mr-4 lg:first:ml-0 lg:last:mr-0 lg:mx-0 lg:w-[calc(20%-21px)] py-6 px-3 hover:from-[rgba(18,10,82,0.6)] hover:to-[rgba(83,77,165,0.95)]"
    >
      <div className="relative w-[100px] h-[100px]">
        <Image src={avatarPath} alt="timer icon" layout={"fill"} />
      </div>
      <Text className="mt-3 text-center">{title}</Text>
      <Text className="opacity-70 text-sm text-center">{subtitle}</Text>
      <Link
        href={linkdn}
        target="_blank"
        highlightOnHover={false}
        withRedirect
        onClick={() => trackTeamLinkedinClick(eventLabel)}
      >
        <LinkedIn
          w={30}
          h={30}
          className="mt-2 ease-in duration-100 scale-1 hover:scale-110 opacity-80 hover:opacity-100"
        />
      </Link>
    </GradientBox>
  )
}
